module.exports = __webpack_public_path__ + "static/media/a36.c379b280.jpg";